import { Link } from "react-router-dom";
import { articles, channels } from "@/mocks/articles";
import { chipSolid, chipSoft } from "@/utils/ui";
import { formatViews } from "@/utils/format";

function channelName(id: string): { name: string; color: string } {
  const c = channels.find((x) => x.id === id);
  return { name: c ? c.name : "吃瓜", color: c ? c.color : "primary" };
}

export default function HeroSection() {
  const featured = [...articles].sort((a, b) => b.views - a.views)[0];
  const others = articles.filter((a) => a.id !== featured.id).slice(0, 4);
  const fcat = channelName(featured.category);

  return (
    <section className="border-b border-background-200 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-6 md:py-8 grid grid-cols-1 lg:grid-cols-12 gap-6 md:gap-7">
        {/* 头条大图 */}
        <div className="lg:col-span-7">
          <Link to={`/article/${featured.id}`} className="group block rounded-xl overflow-hidden bg-background-100 border border-background-200">
            <div className="relative h-[300px] md:h-[420px] overflow-hidden">
              <img
                src={featured.image}
                alt={featured.title}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/25 to-transparent"></div>
              <div className="absolute left-4 md:left-6 bottom-4 md:bottom-6 right-4">
                <div className="flex items-center gap-2">
                  <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium ${chipSolid(fcat.color as never)}`}>
                    {fcat.name}
                  </span>
                  <span className="inline-flex items-center gap-1 text-background-100/80 text-xs">
                    <i className="ri-eye-line"></i>
                    {formatViews(featured.views)}
                  </span>
                </div>
                <h2 className="mt-3 font-heading text-xl md:text-3xl font-bold text-background-50 leading-snug group-hover:underline decoration-primary-400 underline-offset-4">
                  {featured.title}
                </h2>
                <p className="hidden sm:block mt-2.5 text-sm text-background-100/85 line-clamp-2 max-w-2xl">{featured.subtitle}</p>
              </div>
            </div>
          </Link>
        </div>

        {/* 快讯速递 */}
        <div className="lg:col-span-5">
          <div className="flex items-center justify-between mb-4">
            <h2 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
              <span className="w-1.5 h-5 rounded-full bg-primary-500"></span>
              快讯速递
            </h2>
            <span className="text-xs text-foreground-500">持续跟进 · 交叉验证</span>
          </div>

          <div className="space-y-2.5">
            {others.map((a, i) => {
              const cat = channelName(a.category);
              return (
                <Link
                  key={a.id}
                  to={`/article/${a.id}`}
                  className="group flex items-center gap-3.5 p-3 rounded-lg border border-background-200 bg-background-100 hover:border-primary-300 hover:bg-background-50 transition-colors"
                >
                  <span className="font-heading text-lg font-bold text-primary-300 group-hover:text-primary-500 tabular-nums w-5 text-center">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium text-foreground-900 leading-snug line-clamp-2 group-hover:text-primary-700 transition-colors">
                      {a.title}
                    </p>
                    <div className="mt-1.5 flex items-center gap-2 text-xs text-foreground-500">
                      <span className={`inline-flex px-2 py-0.5 rounded-full text-[11px] font-medium ${chipSoft(cat.color as never)}`}>
                        {cat.name}
                      </span>
                      <span className="flex items-center gap-1">
                        <i className="ri-fire-line"></i>
                        {formatViews(a.views)}
                      </span>
                      <span className="hidden sm:inline">{a.date}</span>
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}